import { UAContext } from '@quentin-sommer/react-useragent';
import cn from 'classnames';
import React, { useContext } from 'react';
import Typography from '~components/typography';
import styles from './section-item.module.scss';

interface ISectionItemProps {
  label: string;
  value: string | React.ReactNode;
  mode?: 'vertical' | '';
  fontBold?: boolean;
}
const SectionItem: React.FC<ISectionItemProps & React.HTMLAttributes<HTMLDivElement>> = props => {
  const uaResults = useContext(UAContext).uaResults as UAResults;
  const isMobile = uaResults.mobile;
  const { label, value, mode } = props;
  return (
    <div className={cn(styles.root, { [styles.vertical]: mode === 'vertical' })}>
      <Typography
        component="div"
        className={styles.label}
        variant="body3"
        color={isMobile ? 'var(--color-purple_4)' : 'var(--color-purple_6)'}
      >
        {label}
      </Typography>
      {typeof value === 'string' ? (
        <Typography className={styles.value} variant={isMobile ? 'body3' : 'h9'}>
          {value}
        </Typography>
      ) : (
        value
      )}
    </div>
  );
};

export default SectionItem;
